import React, { useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Main from '../layouts/Main';
import { useApi } from '../contexts/Api';
import BannerList from '../components/BannerList';
import AddBannerDialog from '../components/AddBannerDialog';
import EditBannerDialog from '../components/EditBannerDialog';

const Banners = () => {
  const { banners, loadingBanners, fetchBanners } = useApi();
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);

  const handleAddClick = () => {
    setAddDialogOpen(true);
  };

  const handleEditClick = (banner) => {
    setSelectedBanner(banner);
    setEditDialogOpen(true);
  };

  const handleCloseDialogs = () => {
    setAddDialogOpen(false);
    setEditDialogOpen(false);
    setSelectedBanner(null);
  };

  const handleAddSave = async () => {
    console.log('handleAddSave called');
    setAddDialogOpen(false);
    await fetchBanners();
  };

  const handleEditSave = async () => {
    console.log('handleEditSave called');
    setEditDialogOpen(false);
    setSelectedBanner(null);
    await fetchBanners();
  };

  return (
    <Main>
      <div className="page-header">
        <div>
          <h1 className="page-title">Banners</h1>
          
        </div>
        <div className="ms-auto pageheader-btn">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
          >
            Add New Banner
          </Button>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card custom-card">
            <div className="card-header">
              <div className="card-title">Banner Management</div>
            </div>
            <div className="card-body">
              {loadingBanners ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                  <CircularProgress />
                </Box>
              ) : banners && banners.length > 0 ? (
                <BannerList 
                  banners={banners}
                  onEdit={handleEditClick}
                  onUpdate={fetchBanners}
                />
              ) : (
                <Box textAlign="center" py={5}>
                  <Typography variant="h6" color="text.secondary">
                    No banners found. Add your first banner!
                  </Typography>
                </Box>
              )}
            </div>
          </div>
        </div>
      </div>

      <AddBannerDialog
        open={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
        onSave={handleAddSave}
      />

      <EditBannerDialog
        open={editDialogOpen}
        onClose={() => {
          setEditDialogOpen(false);
          setSelectedBanner(null);
        }}
        banner={selectedBanner}
        onSave={handleEditSave}
      />
    </Main>
  );
};

export default Banners;